import Script from 'next/script';

import type { FrontifyImageContent } from '@/contentful';
import { setImgWidth } from '@/utils/frontify';

const logo: FrontifyImageContent = {
  id: 23854,
  title: 'Off White',
  ext: 'png',
  height: 1080,
  width: 1080,
  created: '2024-01-17T22:53:37.000+00:00',
  generic_url:
    'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9maWxlXC9yaUYzY1l0RnViMmdHWXhCMThqeS5wbmcifQ:sunrun:2xbMQhAAvTYe1dq4uoT9tdjSQMa4CFxwyhbAdfvmj6k?width={width}',
  preview_url:
    'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9maWxlXC9yaUYzY1l0RnViMmdHWXhCMThqeS5wbmcifQ:sunrun:2xbMQhAAvTYe1dq4uoT9tdjSQMa4CFxwyhbAdfvmj6k?width=800',
  src: 'https://cdn-assets-us.frontify.com/s3/frontify-enterprise-files-us/eyJwYXRoIjoic3VucnVuXC9maWxlXC9yaUYzY1l0RnViMmdHWXhCMThqeS5wbmcifQ:sunrun:2xbMQhAAvTYe1dq4uoT9tdjSQMa4CFxwyhbAdfvmj6k?width=800',
};

export default function OrganizationSchema() {
  return (
    <Script type='application/ld+json' strategy='beforeInteractive'>
      {`{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Sunrun",
          "legalName": "Sunrun Inc.",
          "url": "https://www.sunrun.com/",
          "logo": "${setImgWidth(logo.preview_url, 1080, 'png')}",
          "foundingDate": "2007",
          "sameAs": [
            "https://www.facebook.com/sunrun",
            "https://www.instagram.com/sunrunsolar/",
            "https://www.linkedin.com/company/sunrun/",
            "https://www.bbb.org/us/ca/san-francisco/profile/solar-energy-equipment-dealers/sunrun-inc-1116-312886",
            "https://bestcompany.com/solar/sunrun",
            "https://en.wikipedia.org/wiki/Sunrun",
            "https://x.com/sunrun",
            "https://www.pinterest.com/sunrunsolar/",
            "https://www.snapchat.com/place/sunrun/c6b0e1ce-631a-11ea-a6a6-631275128f94",
            "https://vimeo.com/user39148109",
            "https://www.crunchbase.com/organization/sunrun",
            "https://pitchbook.com/profiles/company/43127-29",
            "https://www.zoominfo.com/c/sunrun-inc/353926362",
            "https://www.yellowpages.com/san-marcos-ca/mip/sunrun-inc-502851370",
            "https://www.manta.com/c/mmpx0mw/sunrun",
            "https://www.trustpilot.com/review/sunrun.com",
            "https://www.glassdoor.com/Overview/Working-at-Sunrun-EI_IE384876.11,17.htm",
            "https://github.com/SunRun"
          ],
          "description": "Sunrun Inc. is a leading provider of residential solar energy systems in the United States, offering solar panel installation, battery storage, and energy management solutions designed to help homeowners save on electricity and promote renewable energy adoption.",
          "brand": {
            "@type": "Brand",
            "name": "Sunrun",
            "logo": "${setImgWidth(logo.preview_url, 1080, 'png')}"
          }
        }`}
    </Script>
  );
}
